module.exports = __webpack_public_path__ + "141d4a85/img/share-action-icon.9c12578c.svg";